import { IIconProps } from "@fluentui/react/lib/Icon";
import { getRTL } from "@fluentui/react/lib/Utilities";

import { AppIcons } from "./appIcons";
import { iconNameToIconProps } from "./iconNameToIconProps";

export const getSubmenuIconProps = (
  appIcons: AppIcons
): IIconProps | undefined => {
  const iconName = getRTL()
    ? appIcons.submenuLauncherRtl
    : appIcons.submenuLauncher;
  return iconNameToIconProps(iconName);
};
